import React from 'react';
import { FieldError } from 'react-hook-form';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';
import InfoTooltip from '../InfoTooltip/InfoTooltip';

interface CustomTextAreaProps {
  label?: string;
  tooltip?: string;
  error?: FieldError | undefined;
  type?: string;
  placeholder?: string;
  value?: string;
  name?: string;
  id?: string;
  helperText?: string;
  containerClassName?: string;
  onChange: (event: React.ChangeEvent<HTMLTextAreaElement>) => void;
  onBlur?: (event: React.FocusEvent<HTMLTextAreaElement>) => void;
  className?: string;
  disabled?: boolean;
  fullWidth?: boolean;
  maxLength?: number;
}

const CustomTextArea = React.forwardRef<
  HTMLTextAreaElement,
  CustomTextAreaProps
>(
  (
    {
      label,
      tooltip,
      error,
      value,
      onChange,
      onBlur,
      name,
      type,
      className,
      helperText,
      placeholder,
      containerClassName,
      disabled,
      fullWidth,
      maxLength,
      ...props
    },
    ref
  ) => {
    return (
      <div className={containerClassName ?? 'mb-4'}>
        {label && (
          <div className='mb-2 flex items-center gap-1.5'>
            <Label htmlFor={props.id || name}>{label}</Label>
            {tooltip && <InfoTooltip content={tooltip} />}
          </div>
        )}
        <Textarea
          ref={ref}
          id={props.id || name}
          {...(value !== undefined ? { value } : {})}
          onChange={onChange}
          onBlur={onBlur}
          name={name}
          className={className ?? ''}
          placeholder={placeholder}
          disabled={disabled}
          maxLength={maxLength}
          {...props}
        />
        {helperText && (
          <div className='text-gray-500 text-xs mt-2 ml-1 text-align-left'>
            {helperText}
          </div>
        )}
        {error && (
          <div className='text-red-500 text-xs mt-1 ml-1 text-align-left'>
            {typeof error === 'string' ? error : error.message}
          </div>
        )}
      </div>
    );
  }
);

CustomTextArea.displayName = 'CustomTextArea';

export default CustomTextArea;
